import { Directive, effect, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[libDisableControl]',
})
export class DisableControlDirective {
  libDisableControl = input(false);
  private ngControl = inject(NgControl);

  constructor() {
    effect(() => {
      const action = this.libDisableControl() ? 'disable' : 'enable';
      this.ngControl?.control?.[action]();
    });
  }
}
